/* eslint-disable new-cap */
import type { mxCell, mxGraph } from '@deity-io/mxgraph'; // <- import types only
import mx from 'services/mxGraph/mx'; // <- import values from factory()

export const addPorts = (ports: {}, parentField: mxCell, graph: mxGraph, connectable = true) => {
  // Adds the ports at various relative locations

  Object.keys(ports).forEach((p: any) => {
    let direction: string;
    if (parentField.isEdgesBound && !(parentField.isCollapsed() || parentField.value.editor?.collapsed === true)) {
      direction = 'portPassTrough';
    } else if (ports[p].position.x === 0) {
      direction = 'portLeft';
    } else if (ports[p].position.x === 1) {
      direction = 'portRight';
    } else if (ports[p].position.y === 0) {
      direction = 'portTop';
    } else if (ports[p].position.y === 1) {
      direction = 'portBottom';
    } else {
      direction = 'port';
    }

    const port = graph.insertVertex(
      parentField,
      null,
      { ...ports[p], key: p },
      ports[p].position.x,
      ports[p].position.y,
      18,
      18,
      direction,
      true
    );
    port.geometry.offset = new mx.mxPoint(-9, -9);
    port.isPort = true;
    port.setConnectable(connectable);
  });
};
